import React, { useState } from "react";
import { Box, Typography, Paper, Stack, Chip, TextField } from "@mui/material";
import PutIdeaButton from "../buttons/PutIdeaButton";
import dummyIdeas from "../../../data/dummyIdeas";

export default function IdeaList() {
  const [filter, setFilter] = useState("");

  const filteredIdeas = dummyIdeas.filter((idea) =>
    idea.title.toLowerCase().includes(filter.toLowerCase())
  );

  return (
    <Box sx={{ p: 2 }}>
      {/* Title + Button Row */}
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ mb: 2 }}
      >
        <Typography variant="h6">Submitted CI Ideas</Typography>
        <Stack direction="row" spacing={2} alignItems="center">
          <TextField
            label="Filter Ideas"
            variant="outlined"
            size="small"
            sx={{ width: 300 }}
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
          />
          <PutIdeaButton onClick={() => alert("Idea Submission Modal")} />
        </Stack>
      </Stack>

      {/* List */}
      <Paper elevation={2}>
        {filteredIdeas.map((idea, index) => (
          <Box
            key={idea.id}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              p: 2,
              bgcolor: index % 2 === 0 ? "#fafafa" : "#f4f4f4",
              borderBottom: "1px solid #ddd",
            }}
          >
            <Typography sx={{ flex: 3 }}>{`${index + 1}. ${
              idea.title
            }`}</Typography>
            <Chip
              label={idea.submittedBy}
              size="small"
              color="primary"
              sx={{ flexShrink: 0 }}
            />
            <Typography sx={{ flexShrink: 0, ml: 2 }} variant="body2">
              {idea.date}
            </Typography>
          </Box>
        ))}
      </Paper>
    </Box>
  );
}
